import { useEffect } from "react";

const PmitasksVideo = () => {
//   useEffect(() => {
//     window.parent.postMessage(
//       { action: "redirectTo", label: "points-history" },
//       "*"
//     );
//   }, []);

  return (
    <iframe
      src="https://pmi-salesforce.videomarketingplatform.co/v.ihtml/player.html?token=9817b94132fe6b1a5d5b2f28e1cdfb6e&source=embed&photo%5fid=118727659&endOn=thumbnail"
      width="100%"
      height="600"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default PmitasksVideo;
